import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

const breadcrumbsClasses = tv({
  slots: {
    root: [
      "Breadcrumb__root",
      "flex",
      "flex-wrap",
      "list-none",
      "rounded-small",
      "text-primary-light",
      "my-2",
    ],
    listItem: [
      "[&>*]:!no-underline",
      "[&>*]:cursor-pointer",
      "[&>*]:last:cursor-default",
      "[&>*]:text-sm",
      "font-bold",
      "[&>*]:last:!font-regular",
      "[&>*]:last:!text-slate-400",
      "[&>*]:leading-none",
      "[&>*]:appearance-none",
      "Breadcrumb__item",
      "flex items-center",
    ],
    separator: ["[&_svg]:size-4", "text-slate-400"],
  },
  variants: {
    size: {
      small: {
        listItem: ["[&>*]:text-xs"],
        separator: ["[&_svg]:size-4"],
      },
      medium: {
        listItem: ["[&>*]:text-sm"],
        separator: ["[&_svg]:size-5"],
      },
      large: {
        listItem: ["[&>*]:text-lg"],
        separator: ["[&_svg]:size-6"],
      },
    },
  },
  defaultVariants: {
    size: "small",
  },
});

export const {
  root: breadcrumbsRootClasses,
  listItem: breadcrumbsListItemClasses,
  separator: breadcrumbsSeparatorClasses,
} = breadcrumbsClasses();

export type BreadcrumbsVariants = VariantProps<typeof breadcrumbsClasses>;
